import React from 'react'
import { Box } from 'rebass/styled-components'

const Favicon = ({ name, src, width = '33px', height = '33px', sx }) => (
  <Box
    as="img"
    src={src}
    onError={event => (event.target.src = '/favicon.ico')}
    alt={name}
    loading="lazy"
    sx={{
      width: width,
      height: height,
      borderRadius: '100%',
      display: 'inline-block',
      verticalAlign: 'middle',
      objectFit: 'cover',
      ...sx
    }}
  />
)

export default Favicon
